<template>
      <div v-if="this.return_error && this.$root.errors.length === 0" class="payment-retry-block">
        <button type="button" class="btn_retry" @click="this.call_payment()">Réessayez</button>
      </div>

      <transition name="content-fade">
          <div class="d-flex full-height w-100 flex-column" v-if="!this.return_error">

              <div class="row flex-grow-1"></div>
              <div class="row justify-content-center pb-5">
                  <object data="/assets/kiosk/img/paiement-borne.svg" height="800"></object>
              </div>
              <div class="row justify-content-center pb-5">
                  <div class="big-title w-80">{{this.trans.get('kiosk.instructions')}}</div>
              </div>
              <div class="row justify-content-center pb-5">
                  <div class="icon-arrow-animated d-flex flex-column align-items-center w-25">
                      <object data="/assets/kiosk/img/arrow-borne.svg"></object>
                  </div>
              </div>
          </div>
      </transition>



</template>

<script>
import {callAPI, isset} from "../../helpers/kiosk-helpers";


export default {
    name: "PaymentTerminal",


    data() {
        return {
            data: {},
            bapmi: {},
            test: {},
            return_error: false,
        }
    },
    methods: {
        init(){


            this.data.user_id = this.$root.current_user_id;

            this.data.price = this.$root.cart.price_total_infos.total;
            this.data.total = this.$root.cart.price_total_infos.total;


            this.data.order_id = null;
            this.bapmi = {};

            this.bapmi.billing_account_id = -1;
            this.bapmi.payment_methods = {};
            this.bapmi.payment_methods.idx = 21;
            this.bapmi.payment_methods.amount = this.data['total'];
            this.bapmi.payment_methods.method_data = {};


            this.bapmi.payment_methods = [this.bapmi.payment_methods];

            this.data.bapmi = JSON.stringify([this.bapmi]);



            this.call_payment();
        },
        call_payment(){
            this.return_error = false;
            this.create_order()
                .then(order_id => {
                  this.data['order_id'] = order_id;
                  this.data['hardware_device_uid'] = this.$root.current_tpv;
                  this.$root.order_id = order_id;



                    return new window.Promise((resolve, reject) => {
                        this.$root.set_tpv_to_session()
                            .then(response => {

                                if(response['data']['success'] === 1)
                                {
                                    this.create_payment()
                                        .then(response => {
                                            resolve(response);
                                        })
                                        .catch(error => {
                                            this.$root.addErrors("1"+error,null,String(error));
                                            this.return_error = true;
                                        });
                                }
                                else {
                                    this.$root.addErrors("2"+response['data']['error'],null,'Response fail');
                                    this.return_error = true;
                                }


                            })
                            .catch(error => {
                                this.$root.addErrors("3"+error,null,String(error));
                                this.return_error = true;
                                reject(error);
                            });
                    });
                })
                .catch(error => {
                    this.$root.addErrors("4"+error,null,String(error));
                    reject(error);
            });
        },

        create_order()
        {
            return new window.Promise((resolve, reject) => {

                callAPI(route('api.kiosk.create.order.index'), { user_id: this.$root.current_user_id, total: this.$root.cart.price_total_infos.total }, 'post')
                    .then(response => {

                      this.$root.current_event_is_loaded = this.$root.arrayRemove(this.$root.current_event_is_loaded,'loading-payment');
                      if(isset(response['data']['success']) && response['data']['success'] == 1)
                      {
                        resolve(response['data']['id']);
                      }
                      else {
                        this.$root.addErrors('a-199',null,'Response fail');
                      }

                    })
                    .catch(error => {
                        this.$root.current_event_is_loaded = this.$root.arrayRemove(this.$root.current_event_is_loaded,'loading-payment');
                        this.$root.addErrors('a-199-2',null,String(error));
                        reject(error);
                    });
            });

            //this.$router.push({ name: this.$root.locale + '.purchase-completed' });

        },
        create_payment()
        {

            return new window.Promise((resolve, reject) => {
                callAPI(route('api.kiosk.create.payment.index'),{ data: this.data }, 'post')
                    .then(response => {

                      if(response['data']['success'] === 1)
                      {
                          this.$router.push({ name: this.$root.locale + '.purchase-completed' });
                      }
                      else {
                        let error = response['data']['error'];
                          for (const key in this.$root.errors_tpv) {


                              if(error.indexOf(this.$root.errors_tpv[key]) >= 0)
                              {
                                  error = this.trans.get('kiosk.error_'+key);
                                  break;
                              }

                          }



                        this.$root.addErrors(error,null,'Response fail');
                        this.return_error = true;
                      }

                    })
                    .catch(error => {
                      this.$root.addErrors('a-198',null,String(error));
                      this.return_error = true;
                      reject(error);
                });
            });
        },
    },

    created() {
        this.init();
    },

  emits: [ 'send' ],

}
</script>

<style scoped>

</style>
